import classNames from 'classnames';

export function BulletPoint(props) {
    const {className, content} = props;

    const bulletPointClasses = classNames('bullet-point', 'is-heavy', className);

    return <span className={bulletPointClasses}>{content}</span>;
}
